(function ($, Drupal, drupalSettings) {
  'use strict';

  Drupal.behaviors.dlaHeroVideosMain = {

    attach: function (context, settings) {

      $(document).ready(function() {
        loadMainVideos();
      });

      /**
       * Add click listener to load main video if available
       */
      var loadMainVideos = function () {
        // Click "Watch Now"
        var mainVideoLinks = document.querySelectorAll('.dla-hero-section .dla-field-video a.dla-btn');
        Array.prototype.forEach.call(mainVideoLinks, function (mainVideoLink) {
          mainVideoLink.addEventListener("click", function() {
            var videoContainer;
            if (videoContainer = $(this).closest('.dla-hero-section').find('.dla-hero-video-wrapper')) {
              videoContainer.find('.dla-video')
                .attr("src", "https://www.youtube.com/embed/"+ this.dataset.videohero +"?modestbranding=1&autoplay=1&controls=1&enablejsapi=1&fs=1&loop=1&rel=0&showinfo=0&version=3&autohide=1")
                .closest(".dla-hero-video-container")
                .removeClass("d-none d-md-block");
            }
            // hide content
            videoContainer.closest(".dla-hero-section").find(".dla-hero-content").fadeOut();
            $(".dla-hero-progress").fadeOut();
            $(".dla-hero-nav").fadeOut();
            videoContainer.closest(".dla-hero-section").find(".dla-image-container").fadeOut();
            // Hide gradient
            videoContainer.closest(".dla-hero-section").find("iframe").css('z-index', 1);
            videoContainer.closest(".dla-hero-section").find(".dla-hero-video-wrapper").toggleClass('dla-hero-video-wrapper--playing');
            // Add "playing" class to Watch Now button
            $(this).addClass('playing');
            // show close btn
            videoContainer.closest(".dla-hero-section").find(".dla-hero-overlay-close").fadeIn();
          });
        });
        // Click "Close"
        var mainVideoLinksClose = document.querySelectorAll('.dla-hero-section .dla-hero-overlay-close');
        Array.prototype.forEach.call(mainVideoLinksClose, function (mainVideoLinkClose) {
          mainVideoLinkClose.addEventListener("click", function() {
            var videoContainer;
            if (videoContainer = $(this).closest('.dla-hero-section').find('.dla-hero-video-wrapper')) {
              videoContainer.find('.dla-video')
                .attr("src", "https://www.youtube.com/embed/"+ videoContainer.attr("data-vid") +"?modestbranding=1&autoplay=1&controls=0&enablejsapi=1&fs=0&loop=1&rel=0&showinfo=0&version=3&autohide=1")
                .closest(".dla-hero-video-container")
                .addClass("d-none d-md-block");
            }
            // show content
            videoContainer.closest(".dla-hero-section").find(".dla-hero-content").fadeIn();
            $(".dla-hero-progress").fadeIn();
            $(".dla-hero-nav").fadeIn();
            videoContainer.closest(".dla-hero-section").find(".dla-image-container").fadeIn();
            // Show gradient
            videoContainer.closest(".dla-hero-section").find("iframe").css('z-index', -1);
            videoContainer.closest(".dla-hero-section").find(".dla-hero-video-wrapper").toggleClass('dla-hero-video-wrapper--playing');
            // hide close btn
            videoContainer.closest(".dla-hero-section").find(".dla-hero-overlay-close").fadeOut();
            // Remove all "playing" classes from Watch Now buttons
            $('.dla-btn[data-videohero]').removeClass("playing");
          });
        });

      };

    },

  };

})(jQuery, Drupal, drupalSettings);
